import { add } from '../../orders/services/OrdersService';
import { generatePersonName } from './nameGenerators';

export const generateTestOrders = async (count: number, customerId?: string | null) => {
  const orders = [];
  
  for (let i = 0; i < count; i++) {
    const order = {
      customerId: customerId || `customer-${Math.random().toString(36).substr(2, 9)}`,
      subscriptionId: `subscription-${Math.random().toString(36).substr(2, 9)}`,
      createdByUsername: generatePersonName().toLowerCase().replace(' ', '.'),
    };
    
    const result = await add(order);
    if (result) {
      orders.push(result);
    }
  }
  
  return orders;
};